
import Vue, { PropType } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Customer } from '@sageworks/jpi/';

export default Vue.extend({
	name: 'IconSelectorButton',
	components: {
		FontAwesomeIcon
	},
	props: {
		buttonText: {
			type: String as PropType<string>,
			default: '',
			required: true
		},
		buttonId: {
			type: Number as PropType<number>,
			default: 0,
			required: true
		},
		entityType: {
			type: String as PropType<String>,
			required: true
		},
		iconRight: {
			type: String as PropType<String>,
			required: true
		}
	},
	computed: {
		iconLeft(): string {
			switch (this.entityType.toUpperCase()) {
				case Customer.TypeEnum.Person.toUpperCase():
					return 'user';
				case Customer.TypeEnum.Business.toUpperCase():
					return 'building';
				case Customer.TypeEnum.Farm.toUpperCase():
					return 'farm';
				case Customer.TypeEnum.NonProfit.toUpperCase():
					return 'hands-heart';
				default:
					return '';
			}
		}
	},
	methods: {
		handleClick() {
			this.$emit('useBorrower', this.buttonId);
		}
	}
});
